module.exports = __webpack_public_path__ + "media/blog_elevation_toolbar.15fba0f1.mp4";